import { render, staticRenderFns } from "./DataLogCompareModal.vue?vue&type=template&id=96c75a20&scoped=true&"
import script from "./DataLogCompareModal.vue?vue&type=script&lang=js&"
export * from "./DataLogCompareModal.vue?vue&type=script&lang=js&"
import style0 from "./DataLogCompareModal.vue?vue&type=style&index=0&id=96c75a20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c75a20",
  null
  
)

export default component.exports